import { ref, watch, computed,onMounted } from '@vue/composition-api'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axiosIns from '@/axios'
import store from '@/store'

export default function useOrdersList() {
  // Use toast
  const toast = useToast()

  const refProductsListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'id', sortable: true },
    { key: 'created_date', label: 'İlk kayıt', sortable: true },
    { key: 'image', label: 'Ürün Görseli', sortable: true },
    { key: 'name', label: 'Ürün Adı', sortable: true },
    { key: 'base_price', label: 'Satış Fiyatı', sortable: true },
    { key: 'in_link_count', label: 'link içi/dışı toplamı', sortable: true },
    { key: 'sale_count', label: 'Toplam Satış Adedi', sortable: true },
  ]
  const perPage = ref(store.state.appConfig.perPage)
  const totalProducts = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('sale_count')
  const isSortDirDesc = ref(true)
  const roleFilter = ref(null)
  const planFilter = ref(null)
  const linkFilter = ref(null)
  const productData = ref([])
  const isFirstLoad = ref(true)
  const additionalParams = ref({})

  const dataMeta = computed(() => {
    const localItemsCount = refProductsListTable.value ? refProductsListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalProducts.value,
    }
  })

  const refetchData = () => {
    refProductsListTable.value.refresh()
    fetchProducts();
  }

  watch([currentPage, perPage, searchQuery, roleFilter, planFilter, linkFilter, additionalParams], () => {
   // additionalParams.value.filter nesnesinin tanımlı olup olmadığını kontrol edin, yoksa oluşturun
    if (!additionalParams.value.filter) {
      additionalParams.value.filter = {}; // Eğer filter yoksa, boş bir nesne olarak oluştur
    }

    // statusFilter değerine göre payment_type'u ekleyin veya silin
    if (linkFilter.value !== null && linkFilter.value !== undefined) {
      additionalParams.value.filter.payment_type = linkFilter.value; // id'yi ekle
    } else {
      delete additionalParams.value.filter.payment_type; // Null veya undefined ise payment_type'u sil
    }

    if (!isFirstLoad.value) { // İlk yüklemede değilse çalışsın
      refetchData();
    }
    isFirstLoad.value = false;
  })

  onMounted(() => {
    if(!additionalParams.value.hasFilter){ //eğer filtre olacaksa mounted da data çağırılmasın.
      fetchProducts();
    }
  });

  const fetchProducts = () => {

    const params = {
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      role: roleFilter.value,
      plan: planFilter.value,
      ...additionalParams.value
    };

    axiosIns
      .get('/product', { params })
      .then(response => {
        const { Products, total } = response.data.data;
        totalProducts.value = total;
        productData.value = Products;
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Ürün bulunmuyor.',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
        reject(); // Hata durumunda reject çağırıyoruz
      });
  };

  return {
    fetchProducts,
    tableColumns,
    perPage,
    currentPage,
    totalProducts,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refProductsListTable,

    refetchData,

    // Extra Filters
    roleFilter,
    planFilter,
    linkFilter,

    additionalParams,

    productData
  }
}
